// extracted by mini-css-extract-plugin
export default {"container":"headerSection_container__2sX8+"};